export enum InputValidationState {
    VALID = "valid",
    INVALID = "invalid",
}

export enum FormNames {
    INVOICE = "invoice",
    PARTNER_LINK = "partner_link",
    // Add other form names as needed
}

// Error codes used across the application
export enum ErrorCodes {
    EXPIRED_QUOTE = "EXPIRED_QUOTE",
    CARD_SCHEME_NOT_SUPPORTED = "CARD_SCHEME_NOT_SUPPORTED",
    ORDER_EXPIRED = "ORDER_EXPIRED",
    ORDER_STATUS_NOT_VALID_FOR_PAYMENT = "ORDER_STATUS_NOT_VALID_FOR_PAYMENT",
    ORDER_COMPLETED = "ORDER_COMPLETED",
    ISSUER_COUNTRY_MISMATCH = "ISSUER_COUNTRY_MISMATCH",
    AMOUNT_TOO_LOW = "AMOUNT_TOO_LOW",
    INVALID_BANK_ACCOUNT_DETAILS = "INVALID_BANK_ACCOUNT_DETAILS",
}

// List of error codes for which Sentry alerts should not be sent
export const sentryAlertErrorCodesExceptions = [
    ErrorCodes.CARD_SCHEME_NOT_SUPPORTED,
    ErrorCodes.ORDER_EXPIRED,
    ErrorCodes.ORDER_STATUS_NOT_VALID_FOR_PAYMENT,
    ErrorCodes.ORDER_COMPLETED,
    ErrorCodes.ISSUER_COUNTRY_MISMATCH,
    ErrorCodes.AMOUNT_TOO_LOW,
];

// Error codes for which the user should be redirected to the payment status page when a payment id is present
export const orderErrorCodesForStatusRedirect = [
    ErrorCodes.ORDER_EXPIRED,
    ErrorCodes.ORDER_STATUS_NOT_VALID_FOR_PAYMENT,
    ErrorCodes.ORDER_COMPLETED,
];
